<div class="with-floating-button">
    <div class="content" *ngIf="compte">
        <page-header [title]="isCreation ? ('admin.comptabilite.planComptable.compteComptable.title.creation' | translate) : compte.libelle" [listeItems]="listeTabItems"
                     (onSelectedItemChange)="onSelectedItemChange($event)" (onGoBack)="onGoBack()">
        </page-header>

        <div [hidden]="selectedItem?.code !== Onglets.GENERALITES">
            <form #form="ngForm">
                <compte-comptable-generalites [compte]="compte" [fieldContainer]="fieldContainer"></compte-comptable-generalites>
            </form>
        </div>
        <div *ngIf="isTabLoaded(Onglets.USAGE)" [hidden]="selectedItem?.code !== Onglets.USAGE">
            <compte-comptable-usage [compte]="compte"></compte-comptable-usage>
        </div>
        <div *ngIf="isTabLoaded(Onglets.HISTORIQUE)" [hidden]="selectedItem?.code !== Onglets.HISTORIQUE">
            <compte-comptable-historique [numero]="compte.numero"></compte-comptable-historique>
        </div>
        <floating-button [hidden]="selectedItem?.code !== Onglets.GENERALITES" [listeActions]="listeActions" [isPending]="isPending"></floating-button>
    </div>
</div>